import { Mission } from '@/app/hooks/trade/tradeMission';

export enum MissionCode {
  // onboarding
  SIGNUP_BONUS = 'SIGNUP_BONUS',
  KYC_COMPLETE = 'KYC_COMPLETE',
  FIRST_DEPOSIT_PROMO = 'FIRST_DEPOSIT_PROMO',
  APP_LOGIN_PROMO = 'APP_LOGIN_PROMO',

  // trade
  NET_DEPOSIT_GOAL = 'NET_DEPOSIT_GOAL',
  NET_VOLUME_GOAL = 'NET_VOLUME_GOAL',
  PERIOD_MISSION = 'PERIOD_MISSION',

  // feature
  TRIGGER_ORDER_FIRST = 'TRIGGER_ORDER_FIRST',
  INSTANT_CLOSE_FIRST = 'INSTANT_CLOSE_FIRST',
  TPSL_SETUP_FIRST = 'TPSL_SETUP_FIRST',
  LEVERAGE_FIRST = 'LEVERAGE_FIRST',
  LEVERAGE_GOAL = 'LEVERAGE_GOAL',
  BOT_FIRST_USE = 'BOT_FIRST_USE',
  BOT_VOLUME_GOAL = 'BOT_VOLUME_GOAL',
  DEMO_FIRST_USE = 'DEMO_FIRST_USE',
  DEMO_VOLUME_GOAL = 'DEMO_VOLUME_GOAL',
  COPY_FIRST_USE = 'COPY_FIRST_USE',
  COPY_VOLUME_GOAL = 'COPY_VOLUME_GOAL',
  REFERRAL_GOAL = 'REFERRAL_GOAL',

  // daily
  DAILY_ACTIVITY_GOAL = 'DAILY_ACTIVITY_GOAL',
  ATTENDANCE_STREAK = 'ATTENDANCE_STREAK',
}

export const getMissionTemplateCode = (code: string) => {
  const templateCode = code.replace(/_\d+$/, '') as MissionCode;
  return templateCode;
};

/**
 *
 * @param mission 미션 정보
 * @param index 상세 미션 정보의 tiers의 index
 * @returns canClaim, claimed, notAchieve
 */
export const getClaimStatus = (mission: Mission, index: number) => {
  if (!mission) return 'notAchieve';

  // userProgress가 없는 경우 (비로그인 상태)
  if (!mission.userProgress) return 'notAchieve';

  // 미션에 tiers가 있는 경우
  if (mission.userProgress?.totalTiers && mission.userProgress.totalTiers > 0) {
    const isAchieve = (mission.userProgress?.achievedTiers ?? []).includes(
      index
    );

    // 달성했고, 보상을 받지 않은 경우
    if (isAchieve && !mission.userProgress.claimedTiers?.includes(index)) {
      return 'canClaim';
    }

    // 달성했고, 보상을 받은 경우
    if (isAchieve && mission.userProgress.claimedTiers?.includes(index)) {
      return 'claimed';
    }

    // 달성하지 못한 경우
    return 'notAchieve';
  }

  // 아래는 미션에 tiers가 없는 경우

  // 달성했고, 보상을 받은 경우
  if (mission.userProgress?.claimedAt) {
    return 'claimed';
  }

  // 달성했고, 보상을 받지 않은 경우
  if (mission.userProgress?.canClaim) {
    return 'canClaim';
  }

  // 달성하지 못한 경우
  return 'notAchieve';
};

export const canClaimable = (mission: Mission, index: number) => {
  if (!mission) return false;
  return getClaimStatus(mission, index) === 'canClaim';
};

/**
 * 미션이 tier를 가지고 있는지 확인
 * @param mission 미션 정보
 * @returns tier가 있으면 true, 없으면 false
 */
export const hasTiers = (mission: Mission): boolean => {
  return !!(mission?.userProgress?.totalTiers && mission.userProgress.totalTiers > 0);
};
